import { FaVolleyballBall, FaRunning } from "react-icons/fa";

import { GiTennisCourt, GiShuttlecock } from "react-icons/gi";
// Hero Image
import heroImage from "../assets/services/wooden-flooring/hero.webp";
import overview1 from "../assets/services/wooden-flooring/overview1.webp";
import overview2 from "../assets/services/wooden-flooring/overview2.jpg";
import overview3 from "../assets/services/wooden-flooring/overview3.jpg";
import overview4 from "../assets/services/wooden-flooring/overview4.jpg";
/* =====================================================
   HERO STATS
===================================================== */

// Gallery Images
import gallery1 from "../assets/services/wooden-flooring/gallery1.webp";
import gallery2 from "../assets/services/wooden-flooring/gallery2.jpg";
import gallery3 from "../assets/services/wooden-flooring/gallery3.jpg";
import gallery4 from "../assets/services/wooden-flooring/gallery4.jpg";

const WoodenfloorData = {
  /* =====================================================
     HERO
  ====================================================== */

  slug: "WoodenFloor",

  title: "WoodenFloor Construction",

  subtitle: "Professional Wooden floor Built to MFMA certification",

  heroImage,

  overviewImages: [overview1, overview2, overview3, overview4],

  heroStats: [
    {
      value: "100+",
      label: "Courts Built",
    },

    {
      value: "15+",
      label: "Years Experience",
    },

    {
      value: "MFMA And BWF",
      label: "Certified/Standard",
    },

    {
      value: "5 Yr",
      label: "Warranty",
    },
  ],

  breadcrumb: ["Home", "Services", "Wooden-Flooring"],

  /* =====================================================
     OVERVIEW
  ====================================================== */

  overview: {
    title: "Professional Wooden Flooring Construction",

    description:
      "Our Professional Wooden Flooring is engineered specifically for elite athletic performance and international tournament standards. Crafted from premium, sustainably sourced hardwood, this system features advanced shock-absorption underlayments that minimize player fatigue and prevent joint injuries. It delivers a perfectly uniform ball bounce, exceptional surface grip, and high-gloss durability, making it the premier choice for professional basketball courts, multi-purpose sports arenas, and high-end fitness facilities.",
  },

  /* =====================================================
     BENEFITS
  ====================================================== */

  benefits: [
    {
      title: "MFMA And BWF Standard Certification",
      description:
        "Designed according to international standard specifications.",
    },

    {
      title: "Premium Wooden Surface",
      description:
        "High-performance wooden flooring with excellent grip and durability.",
    },

    {
      title: "Weather Resistant",
      description: "Built to withstand India's harsh climate.",
    },

    {
      title: "Low Maintenance",
      description: "Minimal maintenance with long-lasting surface quality.",
    },
  ],

  /* =====================================================
     CONSTRUCTION PROCESS
  ====================================================== */

  process: [
    {
      step: "01",
      title: "Site Inspection",
      description:
        "Complete site survey, measurements, and technical planning.",
    },

    {
      step: "02",
      title: "Base Preparation",
      description: "Wooden Floor base preparation with perfect leveling.",
    },

    {
      step: "03",
      title: "Acrylic Coating",
      description:
        "Multiple acrylic layers applied for strength and cushioning.",
    },

    {
      step: "04",
      title: "Court Marking",
      description: "Accurate FIBA-standard basketball court line marking.",
    },

    {
      step: "05",
      title: "Final Inspection",
      description: "Complete quality inspection before project handover.",
    },
  ],

  /* =====================================================
     TECHNICAL SPECIFICATIONS
  ====================================================== */

  specifications: [
    {
      icon: "🏀",
      feature: "Surface Type",
      value: "Premium Hard Maple/Teak Wood",
    },

    {
      icon: "🌦",
      feature: "Weather Resistance",
      value: "Optimized for indoor temperature & humidity Stability",
    },

    {
      icon: "👟",
      feature: "Slip Resistance",
      value: "Polyurethane anti-skid scratch-resistant coating",
    },

    {
      icon: "☀",
      feature: "UV Resistant",
      value: "High resistnace against fading from indoor arena lighting",
    },

    {
      icon: "🏆",
      feature: "BWF,WSF And IHF spectifications",
      value: "Level 1 & Level 2 International Compliant",
    },

    {
      icon: "⏳",
      feature: "Expected Lifespan",
      value: "5+ Years",
    },

    {
      icon: "🛠",
      feature: "Maintenance",
      value: "Low Maintenance",
    },

    {
      icon: "🌍",
      feature: "Court Type",
      value: "Indoor",
    },
  ],

  /* =====================================================
     GALLERY
  ====================================================== */

  gallery: [
    {
      image: gallery1,
      title: "DRDO",
      location: "Hyderbad",
      surface: "Premium Maple wood flooring Court",
      year: "2013",
    },

    {
      image: gallery2,
      title: "Delhi Public School",
      location: "Jaipur",
      surface: "Professional Acrylic Court",
      year: "2024",
    },

    {
      image: gallery3,
      title: "Sports Academy",
      location: "Lucknow",
      surface: "Outdoor Basketball Court",
      year: "2024",
    },

    {
      image: gallery4,
      title: "University Campus",
      location: "Chandigarh",
      surface: "FIBA Standard Court",
      year: "2023",
    },
  ],

  /* =====================================================
     WHY CHOOSE US
  ====================================================== */

  whyChoose: {
    tag: "WHY CHOOSE US",

    title: "Why Choose Our Wooden Sports Flooring?",

    description:
      "We combine premium hardwood materials, advanced sports flooring technology and expert installation to deliver safe, durable and high-performance wooden sports floors.",

    features: [
      {
        title: "15+ Years Experience",
        description:
          "Delivering premium sports infrastructure and wooden flooring solutions across India.",
      },

      {
        title: "100+ Sports Projects",
        description:
          "Schools, universities, academies, clubs and professional sports facilities trust us.",
      },

      {
        title: "Premium Hardwood Materials",
        description:
          "High-quality sports-grade hardwood selected for durability, performance and player safety.",
      },

      {
        title: "Expert Installation Team",
        description:
          "Experienced professionals ensuring precise installation and perfect floor performance.",
      },

      {
        title: "On-Time Delivery",
        description:
          "Projects completed within committed timelines with professional project management.",
      },

      {
        title: "Complete Project Support",
        description:
          "Consultation, flooring installation, maintenance guidance and after-sales assistance.",
      },
    ],
  },

  /* =====================================================
     FAQ
  ====================================================== */

  faqs: [
    {
      question:
        "What is the best wood species for athletics and sports flooring?",
      answer:
        "Hard Maple is the industry standard due to its dense grain, high shock resistence, and durability. It resists splintering under heavy impacts compared to other hardwoods.",
    },

    {
      question:
        "What is the difference between area-elastic and point-elastic sports floors?",
      answer:
        "Wooden floors are area-elastic, meaning energy disperses across a wide area when a player lands.Synthetic mats are point-elastic, absorbing shock only at the exact point of contact.",
    },

    {
      question: "How do subfloors clip or pad systems improve player safety?",
      answer:
        "Plywood subfloors rest on resilient rubber pads or steels clips that create an air gap.This specialized underlayment deflects under loads, absorbing impact energy to protect athletes joints.",
    },

    {
      question:
        "Why do sports wooden floors require expansion gaps around the perimeter?",
      answer:
        "Wood naturally expands and contracts with shifting seasonal humidity levels.Leaving a 50mm perimeter gap under the skirting boards prevents the floor from crowning or cracking as it expands",
    },
  ],

  /* =====================================================
       RELATED SERVICES
    ====================================================== */

  relatedServices: [
    {
      icon: GiTennisCourt,
      title: "Tennis Court",
      description: "Professional ITF Standard Courts",
      link: "/services/tennis-court",
    },

    {
      icon: GiShuttlecock,
      title: "Badminton Court",
      description: "Professional BWF Standard Courts",
      link: "/services/badminton-court",
    },

    {
      icon: FaRunning,
      title: "Running Track",
      description: "Athletic Running Track Systems",
      link: "/services/running-track",
    },

    {
      icon: FaVolleyballBall,
      title: "Volleyball Court",
      description: "Professional FIVB Standard Courts",
      link: "/services/volleyball-court",
    },
  ],
  /* =====================================================
     CTA
  ====================================================== */

  cta: {
    title: "Ready to Build Your Wooden floor Court?",

    description:
      "Talk with our experts today and get a free consultation for your next sports infrastructure project.",
  },
};

export default WoodenfloorData;
